// src/stockx/base/HelpIcon.tsx
import { Icon } from "@chakra-ui/icons";
import { jsx, jsxs } from "react/jsx-runtime";
var HelpIcon = ({ colorized, ...props }) => /* @__PURE__ */ jsxs(Icon, { viewBox: "0 0 50 50", ...props, children: [
  colorized && /* @__PURE__ */ jsx(
    "path",
    {
      d: "M25.9 42.9C35.7859 42.9 43.8 34.8859 43.8 25C43.8 15.1141 35.7859 7.09998 25.9 7.09998C16.0141 7.09998 8 15.1141 8 25C8 34.8859 16.0141 42.9 25.9 42.9Z",
      fill: "#D4D1C7"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M25.8999 44C15.3999 44 6.8999 35.5 6.8999 25C6.8999 14.5 15.3999 6 25.8999 6C36.3999 6 44.8999 14.5 44.8999 25C44.8999 35.5 36.3999 44 25.8999 44ZM25.8999 8.2C16.5999 8.2 9.0999 15.8 9.0999 25C9.0999 34.2 16.5999 41.8 25.8999 41.8C35.1999 41.8 42.5999 34.2 42.5999 25C42.5999 15.8 35.0999 8.2 25.8999 8.2Z",
      fill: colorized ? "black" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M29.9001 25C27.9001 26.1 27.1001 26.8 27.1001 29V29.2H23.0001V28.9C23.0001 25.9 24.1001 24.6 26.2001 23.4C28.1001 22.3 29.4001 21.3 29.4001 19.7C29.4001 18.1 27.8001 17.1 26.2001 17.1C24.0001 17.1 22.3001 18.3 22.2001 21.2H18.1001C18.1001 16.8 21.6001 14 26.2001 14C29.9001 14 33.5001 15.7 33.5001 19.5C33.6001 22.3 31.6001 24 29.9001 25ZM22.8001 31.7H27.2001V36.2H22.8001V31.7Z",
      fill: colorized ? "#006340" : "currentColor"
    }
  )
] });
var HelpIcon_default = HelpIcon;

export {
  HelpIcon_default
};
